export const mhist = {
  header_background_color: '#70c497',
  logo_height: 115,
  logo_image_url: 'mhist.png',
  token_url: 'mhist.png',
  number_hidden: true,

  body_background_color: '#efefefff',

  button_color: '#70c497',
  button_text_uppercase: true,
  button_radius: 12,
  button_half_border_color: '#70c497',
  button_outlined_as_default: true,

  text_font: `'Source Sans Pro', sans-serif`,
  title_font: `'Source Sans Pro', sans-serif`,
}

export const aki_explore = {
  body_background_color: '#fbf3c5',

  header_background_color: '#7A559D',

  logo_image_url: 'akiexplore.jpg',
  logo_height: 115,

  token_url: 'akiexplore.png',
  number_hidden: true,

  button_color: '#7a549d',
  button_radius: 50,
  button_border_width: 2,
  button_text_color: '#fbf3c5',
  button_padding: '10px 20px',

  button_hover_color: '#fbf3c5',
  button_hover_text_color: '#7a549d',
  button_hover_border_color: '#7a549d',

  button_outlined_color: '#fbf3c5',
  button_outlined_text_color: '#7a549d',
  button_outlined_hover_color: '#7a549d',
  button_outlined_hover_text_color: '#fbf3c5',

  text_font: `'Source Serif Pro', serif`,
  text_size: 15,
  text_lineheight: 25,

  title_font: `'Source Sans Pro', sans-serif`,
}
